const state = {
    type_section: 0,
    selected_building: null,
    selected_floor: null,
    tree_item: null,
    new_rooms_floor_id: 0,
    selected_room_id: 0,
    floor_to_select: null
};

const getters = {
    type_section(state) {
        return state.type_section;
    },
    selected_building(state) {
        return state.selected_building;
    },
    selected_floor(state) {
        return state.selected_floor;
    },
    tree_item(state) {
        return state.tree_item;
    },
    new_rooms_floor_id(state) {
        return state.new_rooms_floor_id;
    },
    selected_room_id(state) {
        return state.selected_room_id;
    },
    floor_to_select(state) {
        return state.floor_to_select;
    },
};

const mutations = {
    save_type_section(state, payload) {
        state.type_section = payload;
    },
    save_selected_building(state, payload) {
        state.selected_building = payload;
    },
    save_selected_floor(state, payload) {
        state.selected_floor = payload;
    },
    save_tree_item(state, payload) {
        state.tree_item = payload;
    },
    save_new_rooms_floor_id(state, payload) {
        state.new_rooms_floor_id = payload;
    },
    save_selected_room_id(state, payload) {
        state.selected_room_id = payload;
    },
    save_floor_to_select(state, payload) {
        state.floor_to_select = payload;
    }
};

const actions = {
    load_type_section(context, payload) {
        context.commit('save_type_section', payload);
    },
    load_selected_building(context, payload) {
        context.commit('save_selected_building', payload);
    },
    load_selected_floor(context, payload) {
        context.commit('save_selected_floor', payload);
    },
    load_tree_item(context, payload) {
        context.commit('save_tree_item', payload);
    },
    load_new_rooms_floor_id(context, payload) {
        context.commit('save_new_rooms_floor_id', payload);
    },
    load_selected_room_id(context, payload) {
        context.commit('save_selected_room_id', payload);
    },
    load_floor_to_select(context, payload) {
        context.commit('save_floor_to_select', payload);
    },
}

export default {
    mutations,
    actions,
    state,
    getters
};

